import React from 'react'
function SearchText({ query, text = '' }) {
    const markedText = text.replace(new RegExp(query, 'gi'), (match) => `<mark>${match}</mark>`)

    return <div dangerouslySetInnerHTML={{ __html: markedText }} className={'r-search-text'} />
}

export default SearchText
